export enum AppStage {
  local,
  dev,
  test,
  prod,
  docker,
}
